import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  status: "idle",
  userBannerInfo: null,
  error: null,
};

export const getuserBannerInfo = createAsyncThunk(
  "user/getuserBannerInfo",
  async ({ id="", token }, { rejectWithValue }) => {
    try {
      // let url = "/api/users/getuserbannerinfo"
      // if(id){
      //   url = `/api/users/getuserbannerinfo?id=${id}`
      // }
      const { data } = await axios.get(`/api/users/getuserbannerinfo?mid=${id.toString()}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const userBannerInfoSlice = createSlice({
  name: "userbannerinfo",
  initialState,
  reducers: {
    reset(state, action) {
      state.error = null;
      state.userBannerInfo = null;
    },
    resetStatus(state, action) {
      state.status = "idle";
    },
  },
  extraReducers: {
    [getuserBannerInfo.pending]: (state, action) => {
      state.status = "loading";
      state.error = null;
    },
    [getuserBannerInfo.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.error = null;
      state.userBannerInfo = action.payload.userBannerInfo;
    },
    [getuserBannerInfo.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.payload.message;
    },
  },
});

export const { reset, resetStatus } = userBannerInfoSlice.actions;
export default userBannerInfoSlice.reducer;
